import { createUseStyles } from 'react-jss'
import { isMobileOnly } from 'react-device-detect'
import { Color, LightTheme } from '../../../theme'

import { OrderStagingDotStyle } from './order-staging-dot.types'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  container: {
    background: ({ active }: OrderStagingDotStyle) =>
      theme.colors[active ? 'yellow' : 'shadow'],
    height: isMobileOnly ? 32 : 40,
    width: isMobileOnly ? 32 : 40,
    borderRadius: 40,
    cursor: ({ disabled }: OrderStagingDotStyle) =>
      disabled ? 'default' : 'pointer',
    '& >svg': {
      height: isMobileOnly && 20,
      width: isMobileOnly && 20
    },

    '&:hover': {
      background: ({ active, disabled }: OrderStagingDotStyle) => {
        const hover: Color = disabled ? 'shadow' : 'lightBlue'
        const activeColor: Color = active ? 'yellow' : hover
        return theme.colors[activeColor]
      },
      border: ({ disabled }: OrderStagingDotStyle) =>
        !disabled && `2px solid ${theme.colors.yellow}`
    }
  }
}))
